import { createSlice } from "@reduxjs/toolkit";
import { CategoriesAPI } from "../../services/categories";

const Categories = createSlice({
  name: "Categories",
  initialState: {
    categories: [],
    categoryOne: null,
    total: null,
  },
  reducers: {
    setOneCategory: (state, action) => {
      state.categoryOne = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CategoriesAPI.getAll.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.categories = data;
        state.total = data?.length || 0;
      })
      .addCase(CategoriesAPI.getOne.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.categoryOne = data;
      });
  },
});

export const { setOneCategory } = Categories.actions;

export default Categories;
